import React from 'react';
import './Hero.css';

const Hero = () => {
  const handleAnchorClick = (e, href) => {
    
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero" id="hero">
      {/* Background decorations */}
      <div className="hero-deco" />
      <div className="hero-deco2" />
      <div className="hero-grid-pattern" />

      <div className="container hero-inner">
        <div className="hero-layout">
          {/* Left content */}
          <div className="hero-content">
            <div className="hero-pill">
              <div className="hero-pill-dot">
                <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><polygon points="10 8 16 12 10 16 10 8" /></svg>
              </div>
              <span>Now live in Hyderabad</span>
            </div>

            <h1 className="hero-h1">
              Your Story.<br />
              <span className="orange italic">Shot in</span><br />
              Minutes.
            </h1>

            <p className="hero-sub">
              Book a verified professional creator, get cinematic short-form videos delivered instantly — for events, brands, and influencers.
            </p>

            <div className="hero-btns">
              <a href="#contact" className="btn-primary" onClick={(e) => handleAnchorClick(e, '#contact')}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                  <circle cx="12" cy="12" r="10" />
                  <polygon points="10 8 16 12 10 16 10 8" fill="white" stroke="none" />
                </svg>
                Book a Creator
              </a>
              <a href="#creators-join" className="btn-outline" onClick={(e) => handleAnchorClick(e, '#creators-join')}>
                Become a Creator →
              </a>
            </div>

            <div className="hero-stats">
              <div className="hstat">
                <div className="hstat-num">Top</div>
                <div className="hstat-lbl">Creators</div>
              </div>
              <div className="hstat">
                <div className="hstat-num">Multiple</div>
                <div className="hstat-lbl">Reels Shot</div>
              </div>
              <div className="hstat">
                <div className="hstat-num">4.9★</div>
                <div className="hstat-lbl">Avg Rating</div>
              </div>
              <div className="hstat">
                <div className="hstat-num">&lt;30m</div>
                <div className="hstat-lbl">Response</div>
              </div>
            </div>
          </div>

          {/* Right: Phone mockup */}
          <div className="hero-visual reveal rd1">
            {/* Floating cards */}
            <div className="float-card float-card-1">
              <div className="fc-icon" style={{ background: '#FFF0E8' }}>🎬</div>
              <div>
                <div className="fc-label">Reel delivered</div>
                <div className="fc-sub">30 mins after shoot</div>
              </div>
            </div>
            <div className="float-card float-card-2">
              <div className="fc-icon" style={{ background: '#F0FFF4' }}>⭐</div>
              <div>
                <div className="fc-label">5.0 Rating</div>
                <div className="fc-sub">Manish M. · Nagole</div>
              </div>
            </div>
            <div className="float-card float-card-3">
              <div className="fc-icon" style={{ background: '#FFF0E8' }}>📍</div>
              <div>
                <div className="fc-label">3 creators nearby</div>
                <div className="fc-sub">Hyderabad</div>
              </div>
            </div>

            {/* Phone mockup */}
            <div className="hero-phone-wrap">
              <div className="hero-phone">
                <div className="ph-notch" />
                <div className="ph-logo-row">
                  <div className="ph-logo-text"><em>Go</em>Snap</div>
                  <div className="ph-dot" />
                </div>
                <div className="ph-sub">Find creators near you</div>
                <button className="ph-btn">Book Now — from ₹1999</button>
                <div className="ph-cards">
                  <div className="ph-card"><div className="ph-card-n">Reels</div><div className="ph-card-p">₹1999</div></div>
                  <div className="ph-card"><div className="ph-card-n">Events</div><div className="ph-card-p">₹3,499</div></div>
                  <div className="ph-card"><div className="ph-card-n">Brand</div><div className="ph-card-p">₹4,999</div></div>
                </div>
                <div className="ph-creator-row">
                  <div className="ph-avatar" style={{ background: '#2A2A2A' }}>🎥</div>
                  <div>
                    <div className="ph-cr-name">Arjun R.</div>
                    <div className="ph-cr-dist">2km · available</div>
                  </div>
                  <button className="ph-cr-btn">Book</button>
                </div>
                <div className="ph-creator-row">
                  <div className="ph-avatar" style={{ background: '#2A2A2A' }}>📸</div>
                  <div>
                    <div className="ph-cr-name">Priya S.</div>
                    <div className="ph-cr-dist">4km · available</div>
                  </div>
                  <button className="ph-cr-btn">Book</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
